import React from 'react';
import { UrgencyBanner } from './components/UrgencyBanner';
import { Hero } from './components/Hero';
import { PackContents } from './components/PackContents';
import { InitialTestimonials, MoreTestimonials } from './components/Testimonials';
import { PainPoints } from './components/PainPoints';
import { LaunchOffer } from './components/LaunchOffer';
import { FAQ } from './components/FAQ';
import { CostComparison } from './components/CostComparison';
import { EmotionalClose } from './components/EmotionalClose';
import { Footer } from './components/Footer';
import { FloatingNotification } from './components/FloatingNotification';
const TransitionPhrase = () => <div className="mx-auto max-w-3xl px-6 py-4 text-center" data-id="element-0" data-mp="2wk09p15nonvi">
    <p className="font-display text-xl font-[800] italic leading-relaxed text-brand-purpleDark/85 md:text-3xl" data-id="element-1" data-mp="2wiffjcn976y6">
      La próxima sesión puede ser diferente.
    </p>
  </div>;
export function App() {
  return <div className="min-h-screen w-full bg-brand-surface font-sans text-brand-text selection:bg-brand-purple/25 selection:text-brand-purpleDark" data-id="element-2" data-mp="23v2tr4ox335x">
      <UrgencyBanner data-id="element-3" data-mp="3ml1397n9rmih" />
      <main data-id="element-4" data-mp="3mkhou0wtvg97">
        <Hero data-id="element-5" data-mp="3mjzrt22ccy08" />
        <PackContents data-id="element-6" data-mp="3mjg9vlcoy9m7" />
        <InitialTestimonials data-id="element-7" data-mp="3rc9dg5wfbbwp" />
        <PainPoints data-id="element-8" data-mp="3rbzngibdp4r0" />
        <LaunchOffer data-id="element-9" data-mp="3rcsxpt9jqcdw" />
        <MoreTestimonials data-id="element-10" data-mp="3recd7hndojem" />
        <FAQ data-id="element-11" data-mp="5ott78p769p" />
        <CostComparison data-id="element-12" data-mp="6htjo98ovic" />
        <TransitionPhrase data-id="element-13" data-mp="4n6o4eeqtbm" />
        <EmotionalClose data-id="element-14" data-mp="82jt1oitsae" />
      </main>
      <Footer data-id="element-15" data-mp="2zlldgx6hkckm" />
      <FloatingNotification data-id="element-16" data-mp="2zm4yimrfnh2v" />
    </div>;
}